import { EventrGatewayAPI } from "data/gateway.api";
import { SpchatAPI } from "data/spchat.api";
import { chatBackend } from "feat/rocketchat/chatBackend";
import { GUEST_ORG_NAME } from "../../consts";
import { StateCreator } from "zustand";
import { shallow } from "zustand/shallow";
import { BoundStore, useBoundStore } from "../../state/bound.store";
import { isChatAvailable } from "./chat-eligibility";
interface ChatpoolState {}

interface ChatpoolActions {}
export interface IChatpoolSlice extends ChatpoolState, ChatpoolActions {}
export const createChatpoolSlice: StateCreator<
  BoundStore,
  [["zustand/devtools", never]],
  [],
  IChatpoolSlice
> = () => ({});

/** One wake-up per org per minute is plenty; the servers throttle it to one per 15 s. */
const ENSURE_RUNNING_MIN_INTERVAL_MS = 60_000;
const lastEnsureRunning = new Map<string, number>();

const ensureChatRunning = (org: string) => {
  const last = lastEnsureRunning.get(org);
  if (last !== undefined && Date.now() - last < ENSURE_RUNNING_MIN_INTERVAL_MS) return;
  lastEnsureRunning.set(org, Date.now());
  // spchat decides per org: it wakes a proxy org's container and leaves a native org's
  // stopped. The gateway route always wakes the container.
  if (chatBackend() === "spchat") {
    SpchatAPI.ensureRunning(org);
  } else {
    EventrGatewayAPI.rocketchat.ensureRunning(org);
  }
};

/**
 * Starts this module's store subscriptions. `startStoreSubscriptions` (state/store-subscriptions.ts)
 * calls it once, from the app entry, after the whole store graph has loaded.
 */
export function startChatpoolSubscriptions() {
  useBoundStore.subscribe(
    // Keyed on the org's name and whether chat is available, not on the orgConfig object:
    // that is replaced on every config fetch, and each replacement re-sent the request
    // (the gateway answered the repeats with 429).
    (state) => ({
      org: state.selectedOrg?.name,
      chatAvailable: isChatAvailable(state.orgConfig),
    }),
    ({ org, chatAvailable }) => {
      // Sentinel org, not isGuestMode: guest-store may not have hydrated yet here.
      if (!org || org === GUEST_ORG_NAME) return;
      if (chatAvailable) {
        ensureChatRunning(org);
      }
    },
    {
      fireImmediately: true,
      equalityFn: shallow,
    },
  );
}
